import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    CREATE_PERMISSION,
    MAKE_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/make',
        guard: PermissionsGuard,
        roles: {
            permission: MAKE_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/make/MakeCreateView')),
    },
    {
        exact: true,
        path: '/management/makes/:id',
        guard: PermissionsGuard,
        roles: {
            permission: MAKE_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/make/MakeDetailsView')),
    },
    {
        exact: true,
        path: '/management/makes/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: MAKE_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/make/MakeEditView')),
    },
    {
        exact: true,
        path: '/management/makes',
        guard: PermissionsGuard,
        roles: {
            permission: MAKE_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(() => import('src/views/make/MakeListView')),
    },
];
